module.exports = __webpack_public_path__ + "static/media/image_8.64cd5db7.png";